import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TestHooks } from './shortfall-excess-conformation-modal.hooks';

export interface ShortfallExcessConformationModalData {
	context: string;
	amount: number;
}

@Component({
	selector: 'shortfall-excess-conformation-modal',
	templateUrl: './shortfall-excess-conformation-modal.component.html',
	standalone: false,
})
export class ShortfallExcessConformationModalComponent {
	testHooks = TestHooks;
	public context: string;
	public amount: number;
	math = Math;

	constructor(
		public dialogRef: MatDialogRef<ShortfallExcessConformationModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ShortfallExcessConformationModalData,
	) {
		const { context, amount } = data;
		this.context = context;
		this.amount = amount;
	}

	onCancel(): void {
		this.dialogRef.close(false);
	}

	onContinue(): void {
		this.dialogRef.close(true);
	}
}
